import { FunctionComponent, PropsWithChildren } from "react";

import { m as motion, useTransform, useScroll } from "framer-motion";
import { useMedia } from "react-use";
import styled from "styled-components";

import { ButtonBase, ButtonProps, buttonMixin } from "@src/packages/chime-ui/components/Button/Button";
import { colors, media } from "@src/packages/chime-ui/system";
import { screenSizes } from "@src/packages/chime-ui/system/media";

const StyledStickyWrapper = styled(motion.div)`
  ${media.mobileOnly`
     position: fixed;
     bottom: 0;
     left: 0;
     right: 0;
    `}

  background-color: ${colors.white};
  padding: 1.5rem;

  // This keeps the sticky button on top of the footer content
  z-index: 1;

  ${media.tablet`
    padding: 0.5rem 0 0.5rem;
  `}
`;

const StickyWrapper: FunctionComponent<PropsWithChildren<ButtonProps>> = ({ children }) => {
  const isTablet = useMedia(`(min-width: ${screenSizes.tablet}px)`);
  const { scrollY } = useScroll();
  const shadowScale = useTransform(
    scrollY,
    [0, 50],
    ["0px -2px 4px rgba(0, 0, 0, 0)", "0px -2px 4px rgba(0, 0, 0, 0.1)"],
  );

  return (
    <StyledStickyWrapper
      style={{
        boxShadow: isTablet ? "none" : shadowScale,
      }}
    >
      {children}
    </StyledStickyWrapper>
  );
};

export const StickyButtonBase: FunctionComponent<ButtonProps> = ({ children, ...props }) => (
  <StickyWrapper>
    <ButtonBase {...props}>{children}</ButtonBase>
  </StickyWrapper>
);

export const StickyButton = styled(StickyButtonBase)`
  ${buttonMixin}
`;
